import { render, staticRenderFns } from "./TransparencySubTypes.vue?vue&type=template&id=a8ec2b94&scoped=true&"
import script from "./TransparencySubTypes.vue?vue&type=script&lang=js&"
export * from "./TransparencySubTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ec2b94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
